/*global plupload*/
define('lib/fileuploader/file',['require','underscore'],function(require) {

  var _ = require('underscore');

  var PodioUploaderFile = function(pluploadFile) {
    var self = this; // Setup alias for self to reduce code size when it's compressed

    self.id = null;
    self.fileId = null;
    self.mimeType = null;
    self.icon = null;
    self.name = name;
    self.size = 0;
    self.isImage = false;

    if (pluploadFile) {
      self = _.extend(self, pluploadFile);
      self.mimeType = plupload.mimeTypes[self.name.replace(/^.+\.([^.]+)/, '$1').toLowerCase()] || 'application/octet-stream';
      self.isImage = self.mimeType.indexOf('image') > -1 && (!/tiff|tif|x-tiff|x-tif/.test(self.mimeType));
    }

  };

  PodioUploaderFile.prototype.createFromPodioFile = function(podioFile) {
    var self = this;

    self.id = podioFile.file_id;
    self.fileId = podioFile.file_id;
    self.name = podioFile.name;
    self.size = podioFile.size;
    self.icon = podioFile.icon;
    self.mimeType = podioFile.mimetype;

    self.isImage = self.mimeType.indexOf('image') > -1 && (!/tiff|tif|x-tiff|x-tif/.test(self.mimeType));

    self.podioFile = podioFile;

    return self;
  };

  return PodioUploaderFile;

});

